import React from "react";
import { REGIONS, MARKET_MARQUEE } from "./data";
import { useRevealGroup } from "../../hooks/useReveal";

const Geography = () => {
  const ref = useRevealGroup(".reveal");
  return (
    <section
      ref={ref}
      className="py-24 lg:py-32"
      style={{ backgroundColor: "#0A0A0A" }}
      data-testid="geography-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="reveal max-w-[820px]">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-num-gold" />
            <span className="font-ui text-[9px] uppercase text-num-gold track-eyebrow">
              Our Markets
            </span>
          </div>
          <h2 className="font-display font-medium text-num-cream leading-[1.05]" style={{ fontSize: "clamp(38px, 5vw, 60px)" }}>
            Rooted in Delhi.<br />
            <span className="font-italic italic font-normal text-num-gold-light">Reaching Beyond.</span>
          </h2>
          <p className="font-body italic text-[15px] mt-6" style={{ color: "rgba(247,243,236,0.55)" }}>
            Active across Delhi NCR — entering Pan-India and International markets. We deal in
            every asset class at every ticket size.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {REGIONS.map((r, i) => (
            <div
              key={r.name}
              className={`reveal delay-${i + 1} group relative overflow-hidden aspect-[4/5]`}
              data-testid={`region-card-${i}`}
            >
              <div className="img-zoom absolute inset-0">
                <img src={r.image} alt={r.name} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div
                className="absolute inset-0"
                style={{ background: "linear-gradient(to top, rgba(28,6,6,0.92), rgba(28,6,6,0.15) 60%)" }}
              />
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <span className="block w-8 h-px bg-num-gold mb-4 group-hover:w-16 transition-all duration-500" />
                <div className="font-display text-num-cream font-medium leading-tight" style={{ fontSize: "22px" }}>
                  {r.name}
                </div>
                <div className="font-ui text-[10px] track-label uppercase mt-2" style={{ color: "rgba(247,243,236,0.75)" }}>
                  {r.sub}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Marquee */}
        <div className="mt-16 marquee-mask overflow-hidden border-y border-num-gold/20 py-6">
          <div className="flex w-max animate-marquee gap-12 whitespace-nowrap">
            {[...MARKET_MARQUEE, ...MARKET_MARQUEE].map((m, i) => (
              <span
                key={i}
                className="font-ui text-[12px] uppercase track-label text-num-gold flex items-center gap-12"
              >
                {m}
                <span className="block w-1.5 h-1.5 rotate-45 bg-num-gold" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Geography;
